<template>
  <div class="feedback-step">
    <div
      v-if="currentStep === '1'"
      class="step"
    >
      <h3>Olá. Tudo bem?</h3>
      <h2>O que você está achando do novo sistema AOL 2.0?</h2>
      <feedback-grade :grade.sync="grade" />
      <button
        :disabled="grade===null"
        class="btn btn-medium btn-secondary btn-send"
        @click="sendRate"
      >
        ENVIAR RESPOSTA
      </button>
    </div>
    <div
      v-if="currentStep === '2'"
      class="step"
    >
      <h3>Obrigado por sua avaliação =)</h3>
      <h2>Para terminar, poderia nos dizer o motivo da sua opinião?</h2>
      <textarea
        v-model="comment"
        maxlength="1000"
        class="feedback-comment"
      />
      <button
        class="btn btn-medium btn-septenary btn-cancel"
        @click="finishFeedback"
      >
        NÃO TENHO NADA A COMENTAR
      </button>
      <button
        :disabled="!comment"
        class="btn btn-medium btn-secondary btn-send"
        @click="sendComment"
      >
        ENVIAR RESPOSTA
      </button>
    </div>
    <div
      v-if="currentStep === '3'"
      class="last-step"
    >
      <img src="/static/images/nps-avatar.png">
      <h3>Obrigado pela sua ajuda!</h3>
      <h2>Agora podemos melhorar nossos serviços graças à você.</h2>
      <button
        class="btn btn-medium btn-secondary btn-close"
        @click="closeFeedbackModal"
      >
        FECHAR
      </button>
    </div>
  </div>
</template>

<script>
import feedbackGrade from './FeedbackGrade.vue'
import {feedback, feedbackMapping} from '@/api/feedback'
import {mapGetters} from 'vuex'
import mixin from './feedbackMixin'
export default {
  components: {
    'feedback-grade': feedbackGrade
  },
  mixins: [mixin],
  data () {
    return {
      currentStep: '1',
      grade: null,
      comment: null
    }
  },
  computed: {
    ...mapGetters(['profile'])
  },
  watch: {
    isFeedbackModalVisible: function (newValue) {
      if (this.currentStep !== '1') {
        this.grade = null
        this.comment = null
        var self = this
        setTimeout(function () {
          self.currentStep = '1'
        }, 5000)
      }
    },
    grade: function (newValue) {
      if (newValue) {
        this.$analytics.pushAnalyticsEvent('ga-event', {
          'category': 'NPS-Cliques',
          'action': newValue,
          'label': this.feedbackCurrentView
        })
      }
    }
  },
  created () {
    this.stepAnalytics('nps-solicita-nota')
  },
  methods: {
    resetCounter () {
      let feedbackConfig = feedbackMapping[this.feedbackCurrentView]
      feedback.resetCounter(feedbackConfig.counter)
    },
    sendRate () {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'NPS-Envio-Nota',
        'action': this.grade,
        'label': this.feedbackCurrentView
      })
      this.stepAnalytics('nps-sucesso-de-envio-nota')
      this.resetCounter()
      this.currentStep = '2'
      this.stepAnalytics('nps-solicita-comentario')
    },
    sendComment () {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        'category': 'NPS-Envio-Coment',
        'action': this.comment,
        'label': this.feedbackCurrentView
      })
      this.stepAnalytics('nps-sucesso-de-envio-comentario')
      this.currentStep = '3'
    },
    finishFeedback () {
      this.currentStep = '3'
    },
    stepAnalytics (step) {
      this.$analytics.pushAnalyticsEvent('vpageview', {
        'page': '/modal/' + step,
        'id-usuario': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'nlab': this.profile.laboratoryName
      })
    }
  }
}
</script>

<style lang="scss">
  .feedback-step {
    h3 {
      font-size: 18px;
      font-weight: 400;
      margin-bottom: 2px;
    }

    h2 {
      font-size: 18px;
    }

    .btn-cancel {
      float: left;
      width: 58%;
      background-color: #c2c2c2;
    }

    .btn-send {
      float: right;
      width: 183px;
      font-weight: 400;

      &:disabled {
        background-color: #d9d9d9;
        cursor: not-allowed;
      }
    }

    .feedback-comment {
      display: block;
      width: 100%;
      height: 107px;
      resize: none;
      overflow: auto;
      outline: 0;
      border-radius: 6px;
      border: 1px solid #979797;
      margin: 20px 0 15px;
      padding: 10px;
      font-family: Roboto, sans-serif;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
    }

    .last-step {
      text-align: center;

      img {
        margin-bottom: 17px;
      }

      h2 {
        margin-bottom: 30px;
      }

      .btn-close {
        width: 143px;
        font-weight: 400;
        margin: 0 auto;
      }
    }
  }
</style>
